export enum DatePresetEnum {
    TODAY = "TODAY",
    YESTERDAY = "YESTERDAY",
    LAST_7_DAYS = "LAST_7_DAYS",
    LAST_30_DAYS = "LAST_30_DAYS",
    THIS_MONTH = "THIS_MONTH",
    LAST_MONTH = "LAST_MONTH",
    THIS_YEAR = "THIS_YEAR",
    LAST_YEAR = "LAST_YEAR",
    CUSTOM = "CUSTOM",
}

export enum ReportMetricEnum {
    STAGE = "stage",
    STATUS = "status",
    PRIMARY_SOURCE = "primarySource",
    SOURCE = "source",
    ASSIGN_TO = "assignTo",
    CREATED_AT = "createdAt",
}

export enum ChartTypeEnum {
    BAR = "bar",
    LINE = "line",
    PIE = "pie",
    DOUGHNUT = "doughnut",
    AREA = "area",
}

export interface ReportRequest {
    // Date preset is now optional (API can work without date filtering)
    datePreset?: DatePresetEnum;
    // UI stores axis as simple string (metric value or custom field id)
    xAxis: string;
    yAxis: string;
    startDate?: string;
    endDate?: string;
    chartType?: ChartTypeEnum;
    reportName?: string;
    reportId?: string;
    description?: string;
    /** Reporting module context (defaults to LEAD if not provided) */
    module?: ReportModuleEnum;
    /** Metric aggregation type. Backend currently supports only 'count'. */
    metric?: 'count';
    /** Flag indicating if the report is pinned for quick access */
    isPinned?: boolean;
    /** Active organization identifier to scope report data */
    organization: string;
}

export interface ReportResponse {
    xLabels: string[];
    yLabels: string[];
    count: number[][];
}

export interface SavedReport {
    id: string;
    name: string;
    description?: string;
    datePreset: DatePresetEnum | undefined; // preserved for backward compatibility
    xAxis: string;
    yAxis: string;
    chartType: ChartTypeEnum;
    createdAt: string;
    updatedAt: string;
    createdBy: string;
    isTemplate?: boolean;
    module?: ReportModuleEnum;
    metric?: 'count';
    isPinned?: boolean;
    organization?: string;
}

export interface ReportMetric {
    value: string;
    label: string;
    type: 'dimension' | 'measure';
    description?: string;
}

// New: Module Enum (also duplicated as const in lib/const.ts for option lists)
export enum ReportModuleEnum {
    LEAD = 'LEAD',
    ACTIVITY = 'ACTIVITY',
    TODO = 'TODO',
    APPROVAL_REQUEST = 'APPROVAL_REQUEST'
}

// Internal axis object shape used only when constructing API payload
export interface AxisPayload {
    value: string;
    isCustomField: boolean; // backend expects explicit true/false
}
